import React from "react";
import {Route, Routes} from "react-router-dom";
import RegistrationCreateEdit from "./RegistrationCreateEdit";
import RegistrationList from "./RegistrationList";


/* Note: Additional public routes in main app router.js */

function SummerSchoolRouter() {
    return (
        <Routes>
            <Route index element={<RegistrationList/>}/>
            <Route path="registrations/:id/edit" element={<RegistrationCreateEdit/>}/>
            <Route path="registrations/new" element={<RegistrationCreateEdit/>}/>
            <Route path="registrations/:id/:secret/edit" element={<RegistrationCreateEdit/>}/>
        </Routes>
    );
}

export function SummerSchool() {

    return <SummerSchoolRouter/>
}

